import { IItemForGetShortInfo, ITotalPrice, IItemForGetShortDishInfo } from 'types';
import React from 'react';
import SuggestedDishCategorySelect from './components/SuggestedDishCategorySelect';
import SuggestedDishSubCategorySelect from './components/SuggestedDishSubCategorySelect';
import SuggestedDishMultipleSelect from './components/SuggestedDishMultipleSelect/SuggestedDishMultipleSelect';
import DnDList from './components/DnDList';
import style from './SuggestedDishesField.module.scss';

interface ISuggestedDishesField {
	setSuggestedDishes: (value: string[]) => void;
	setSuggestedDishCategory: (value: Nullable<string>) => void;
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	totalPrices: ITotalPrice[];
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	setFetchedSuggestedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedSuggestedDishCategory: Nullable<string>;
	setFetchedSuggestedDishes: (value: IItemForGetShortInfo[]) => void;
	selectedSuggestedDishSubCategory: Nullable<string>;
	selectedSuggestedDishes: string[];
	removeSuggestedDish: (Value: string) => void;
	fetchedSuggestedDishes: IItemForGetShortDishInfo[];
}

const SuggestedDishesField: React.FC<ISuggestedDishesField> = ({
	totalPrices,
	setSuggestedDishCategory,
	setSuggestedDishes,
	setFetchedCategories,
	selectedSuggestedDishCategory,
	setSuggestedDishSubCategory,
	setFetchedSuggestedDishSubCategories,
	selectedSuggestedDishes,
	selectedSuggestedDishSubCategory,
	setFetchedSuggestedDishes,
	fetchedSuggestedDishes,
	removeSuggestedDish,
}) => {
	return (
		<div className={style.container} data-test="SuggestedDishesField">
			<div className={style.newSuggestedDishFields}>
				<SuggestedDishCategorySelect
					totalPrices={totalPrices}
					setSuggestedDishCategory={setSuggestedDishCategory}
					setFetchedCategories={setFetchedCategories}
				/>
				<SuggestedDishSubCategorySelect
					selectedSuggestedDishCategory={selectedSuggestedDishCategory}
					setSuggestedDishSubCategory={setSuggestedDishSubCategory}
					setFetchedSuggestedDishSubCategories={setFetchedSuggestedDishSubCategories}
				/>
				<SuggestedDishMultipleSelect
					selectedSuggestedDishes={selectedSuggestedDishes}
					selectedSuggestedDishSubCategory={selectedSuggestedDishSubCategory}
					setSuggestedDishes={setSuggestedDishes}
					setFetchedSuggestedDishes={setFetchedSuggestedDishes}
				/>
			</div>
			<DnDList
				selectedSuggestedDishes={selectedSuggestedDishes}
				fetchedSuggestedDishes={fetchedSuggestedDishes}
				setSuggestedDishes={setSuggestedDishes}
				removeSuggestedDish={removeSuggestedDish}
			/>
		</div>
	);
};

export default React.memo(SuggestedDishesField);
